"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _LeaderboardList = _interopRequireDefault(require("./LeaderboardList"));

var _LeaderboardMyBet = _interopRequireDefault(require("./LeaderboardMyBet"));

var _LeaderboardEmpty = _interopRequireDefault(require("./LeaderboardEmpty"));

var _actions = require("./actions");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top: 4rem;\n"])));

var StyledButtonWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 1.5rem;\n"])));

var Leaderboard = function Leaderboard(_ref) {
  var translations = _ref.translations,
      history = _ref.history,
      app = _ref.app,
      betbar = _ref.betbar,
      setBetbar = _ref.setBetbar,
      hidePrizeMoney = _ref.hidePrizeMoney,
      showPrizeIcons = _ref.showPrizeIcons,
      showPrizeIconIfAllQuestionsCorrect = _ref.showPrizeIconIfAllQuestionsCorrect,
      showPrizeIconIfAllButOneQuestionsCorrect = _ref.showPrizeIconIfAllButOneQuestionsCorrect,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages;
  var dispatch = (0, _reactRedux.useDispatch)();
  var pageNumber = (0, _react.useRef)(1);

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state;
  }),
      leaderboard = _useSelector.leaderboard;

  var activePickem = betbar.activePickem,
      isActivePickemInPlay = betbar.isActivePickemInPlay,
      isActivePickemApproved = betbar.isActivePickemApproved,
      isBetsOpen = betbar.isBetsOpen,
      activeBet = betbar.activeBet,
      hadBet = betbar.hadBet,
      isShowingMyBet = betbar.isShowingMyBet,
      table = betbar.table,
      isBetbarLoading = betbar.isBetbarLoading;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state.leaderboard;
  }),
      loading = _useSelector2.loading,
      hasMore = _useSelector2.hasMore,
      canBet = _useSelector2.canBet,
      pickemList = _useSelector2.pickemList,
      filterByMe = _useSelector2.filterByMe,
      currentMatch = _useSelector2.currentMatch; // usePusherLeaderboard();


  var activePickemId = activePickem === null || activePickem === void 0 ? void 0 : activePickem.id;
  var activeBetId = activeBet === null || activeBet === void 0 ? void 0 : activeBet.betId;
  var isShowingToolbarLower = isActivePickemApproved === false && isBetsOpen === false;
  var isScrolledDown = app.isScrolledDown,
      loggedInUserName = app.loggedInUserName,
      loggedInUserImage = app.loggedInUserImage;
  (0, _react.useEffect)(function () {
    if (activePickem !== null && activePickem !== void 0 && activePickem.id) {
      console.log("activePickem?.id has changed!!", activePickem, activeBet); // dispatch(setLoading(true));

      dispatch((0, _actions.getLeaderboard)(activePickem, activeBet, false, false, betbar, setBetbar));
    }
  }, [activePickem === null || activePickem === void 0 ? void 0 : activePickem.id]);
  (0, _react.useEffect)(function () {
    if (hadBet) {
      window.xtremepush("tag", "leaderboard", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE,
        ContestName: activePickem === null || activePickem === void 0 ? void 0 : activePickem.name
      }));
      window.xtremepush("event", "Leaderboard", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE,
        ContestName: activePickem === null || activePickem === void 0 ? void 0 : activePickem.name
      }));
    }
  }, [hadBet, activePickem]);
  var isCompleted = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "COMPLETED";
  var isApproved = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED";
  var isPreMatchLeaderboard = isApproved || isActivePickemInPlay && !(table !== null && table !== void 0 && table.length);
  var isLeaderboardEmpty = leaderboard.isLeaderboardEmpty,
      isPickemEmpty = leaderboard.isPickemEmpty;
  var hasBet = activeBet;
  var hasPrizeOverride = false;

  if (showPrizeIconIfAllQuestionsCorrect) {
    var _activePickem$questio;

    var questionCount = activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$questio = activePickem.questions) === null || _activePickem$questio === void 0 ? void 0 : _activePickem$questio.length;
    hasPrizeOverride = questionCount === (activeBet === null || activeBet === void 0 ? void 0 : activeBet.points);
  }

  if (showPrizeIconIfAllButOneQuestionsCorrect) {
    var _activePickem$questio2;

    var _questionCount = activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$questio2 = activePickem.questions) === null || _activePickem$questio2 === void 0 ? void 0 : _activePickem$questio2.length;

    hasPrizeOverride = _questionCount - 1 === (activeBet === null || activeBet === void 0 ? void 0 : activeBet.points);
  }

  if (activeBet !== null && activeBet !== void 0 && activeBet.hasWinTieBreaker) {
    hasPrizeOverride = true;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    isShowingToolbarLower: isShowingToolbarLower,
    noTopPadding: isPickemEmpty,
    children: [!isBetbarLoading && !loading && leaderboard && isPickemEmpty && !canBet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.EmptyScreen, {
        colorText: "rgba(255, 255, 255, 0.96)",
        colorLabel: "rgba(255, 255, 255, 0.66)",
        emptyIcon: "cancel_presentation",
        emptyTitle: "No Active Match",
        emptySubtitle: "Next match soon"
      })
    }) : null, !isBetbarLoading && !loading && leaderboard && isLeaderboardEmpty && canBet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.EmptyScreen, {
        colorText: "rgba(255, 255, 255, 0.96)",
        colorLabel: "rgba(255, 255, 255, 0.66)",
        emptyIcon: "touch_app",
        emptyTitle: translations.leaderboardMakePicksTitle,
        emptySubtitle: translations.leaderboardMakePicksSubtitle
      })
    }) : null, !isBetbarLoading && !loading && isLeaderboardEmpty && !hadBet && !canBet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.EmptyScreen, {
        colorText: "rgba(255, 255, 255, 0.96)",
        colorLabel: "rgba(255, 255, 255, 0.66)",
        emptyIcon: "block",
        emptyTitle: translations.leaderboardNotEnteredTitle,
        emptySubtitle: translations.leaderboardNotEnteredSubtitle
      })
    }) : null, !isBetbarLoading && !loading && !(table !== null && table !== void 0 && table.length) && hadBet && !canBet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardEmpty.default, {
      app: app,
      translations: translations,
      betbar: betbar,
      isUsingAlternativeImages: isUsingAlternativeImages
    }) : null, !isPreMatchLeaderboard && hadBet && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardMyBet.default, {
      translations: translations,
      activeBet: activeBet,
      app: app,
      hidePrizeMoney: hidePrizeMoney,
      hasPrizeOverride: hasPrizeOverride,
      showPrizeIconIfAllQuestionsCorrect: showPrizeIconIfAllQuestionsCorrect,
      showPrizeIconIfAllButOneQuestionsCorrect: showPrizeIconIfAllButOneQuestionsCorrect
    }), !isLeaderboardEmpty && /*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaderboardList.default, {
      translations: translations,
      app: app,
      betbar: betbar,
      setBetbar: setBetbar,
      hidePrizeMoney: hidePrizeMoney,
      hasPrizeOverride: hasPrizeOverride,
      showPrizeIcons: showPrizeIcons
    })]
  });
};

var _default = Leaderboard;
exports.default = _default;